export enum GenderType {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}
